var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestClient } from '@pegasus/rest-client';
export const fetchDataLayer = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield RestClient.get('/api/tracking/clients/me/events/ga4').send();
        const dataLayer = yield response.json();
        const lead = response.headers.get('X-Lead-Event') === 'true';
        return { dataLayer, lead };
    }
    catch (e) {
        return { dataLayer: {}, lead: false };
    }
});
